module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.shown),
      callback: function($$v) {
        _vm.shown = $$v
      },
      expression: "shown"
    }
  }, [(_vm.shown) ? _c('v-card', {
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.shown = false
      },
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('crud.filters')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.shown = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "max-height": "900px"
    }
  }, _vm._l((Object.keys(_vm.fields).filter(function (field) { return _vm.fields[field].list; })), function(field) {
    return _c('v-flex', {
      key: field
    }, [(_vm.fields[field].filterable) ? _c('crud-filter', {
      attrs: {
        "options": _vm.fields[field],
        "field": field
      },
      model: {
        value: (_vm.value),
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    }) : _vm._e()], 1)
  })), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "type": "submit",
      "success": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('crud.filter.clear')))])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2304785c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Crud/CrudFilterDialog.vue
// module id = 1058
// module chunks = 1